module.exports = __webpack_public_path__ + "img/bdzh.9c0af2ae.png";